module.exports = "<div>\n  <ticket-list\n    @load-ticket=\"loadTicket\"\n    v-if=\"$router.currentRoute.path === '/tickets'\" />\n  <router-view\n    @load-ticket=\"loadTicket\"\n    :tiny-mce=\"tinyMce\"\n    :active-ticket=\"activeTicket\">\n  </router-view>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/admin/support/tickets/template.html
// module id = WOft
// module chunks = 0